// Material thumbnails — photorealistic 3D product renders.
// Category text → PNG asset under /material-images/.
import React from "react";

const CATEGORY_RULES = [
  [/fibre/i, "fibre-cement-slate"],
  [/slate/i, "natural-slate"],
  [/clay/i, "clay-tiles"],
  [/concrete/i, "concrete-tiles"],
  [/underlay|membrane/i, "underlay"],
  [/batten/i, "battens"],
  [/dry\s*ridge|ridge/i, "dry-ridge"],
  [/dry\s*verge|verge/i, "dry-verge"],
  [/ventilation|vent/i, "ventilation"],
  [/epdm|rubber/i, "epdm"],
  [/grp|fibreglass/i, "grp-fibreglass"],
  [/fascia|soffit/i, "fascia-soffit"],
  [/lead/i, "leadwork"],
  [/standing\s*seam/i, "standing-seam"],
  [/corrugated|sheet/i, "corrugated"],
  [/composite|panel/i, "composite-panel"],
];

function resolveKey(category = "", name = "") {
  const text = `${category} ${name}`;
  return CATEGORY_RULES.find(([re]) => re.test(text))?.[1] || "concrete-tiles";
}

export function MaterialThumb({ category = "", name = "", className = "", size = 44 }) {
  const key = resolveKey(category, name);
  return (
    <div
      className={`shrink-0 border border-slate-200 overflow-hidden bg-white grid place-items-center ${className}`}
      style={{ width: size, height: size }}
    >
      <img
        src={`/material-images/${key}.png`}
        alt={name || key}
        className="w-full h-full object-contain"
        loading="lazy"
        draggable={false}
      />
    </div>
  );
}

export default MaterialThumb;
